import React from 'react';
const painPoints = ['Llegás a cada clase sin un plan claro y terminás improvisando sobre la marcha frente a tus alumnos', 'Tus clases no tienen estructura y los alumnos no sienten que progresan, entonces se van sin avisarte', 'Perdés horas cada semana pensando qué enseñar hoy en lugar de enfocarte en hacer crecer tu dojo', 'La deserción te come los ingresos mes a mes y no encontrás la manera de frenarla', 'No tenés un sistema de cobros ni de gestión y a fin de mes los números no cierran', 'Ves a otros dojos con más alumnos y más orden y no entendés qué están haciendo diferente'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(32, 8, 8)',
    backgroundImage: 'linear-gradient(180deg, rgb(20, 0, 0) 0%, rgb(12, 5, 5) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-152">
      <div className="mx-auto max-w-3xl" data-id="element-153">
        {/* LABEL */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-154">
          😔 ¿Te sentís identificado?
        </p>

        {/* TÍTULO */}
        <h2 className="text-center text-2xl sm:text-3xl font-black text-white m-0 mb-2" data-id="element-155">
          Esto le pasa al 90% de los instructores
          <br data-id="element-156" />
        </h2>

        {/* SUBTÍTULO */}

        {/* PAIN POINTS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-157">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-gray-900 border border-red-900 rounded-xl p-4 shadow-sm" data-id="element-158">
              <span className="text-red-500 text-base leading-5 shrink-0 font-black" data-id="element-159">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-200 m-0" data-id="element-160">{point}</p>
            </div>)}
        </div>

        {/* PREGUNTA CIERRE */}
        <div className="bg-red-600 rounded-2xl px-6 py-5 text-center mb-6" data-id="element-161">
          <p className="text-white sm:text-xl font-black m-0 mb-1 text-[13px]" data-id="element-162">
            Cada clase improvisada es una clase
            <br data-id="element-163" />
            <span className="text-yellow-300 text-[13px]" data-id="element-164">
              que le abre la puerta de salida a un alumno.
            </span>
          </p>
        </div>

        {/* CTA DENTRO DEL DOLOR */}
        <div className="text-center mb-6" data-id="element-165"></div>

        {/* DIVISOR */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0), rgb(196, 30, 58), rgba(0, 0, 0, 0))'
      }} data-id="element-166" />
      </div>
    </section>;
}